import { UIRouter } from '@uirouter/angular';
import { registerTransitionHooks } from './register-transition-hooks';

export function configureRouter(uiRouter: UIRouter) {
    registerTransitionHooks(uiRouter.transitionService);
}



// WEBPACK FOOTER //
// ./src/app/blocks/config/router.config.ts